export class ResponseModel<T = any> {
  error_code: string | null;
  return_object: T | null;

  constructor(obj: any = {}) {
    this.error_code = obj && obj.error_code || null;
    this.return_object = obj && obj.return_object || null;
  }
}
